import { render, staticRenderFns } from "./Rp.vue?vue&type=template&id=5a6f2c7d&scoped=true"
import script from "./Rp.vue?vue&type=script&lang=js"
export * from "./Rp.vue?vue&type=script&lang=js"
import style0 from "./Rp.vue?vue&type=style&index=0&id=5a6f2c7d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a6f2c7d",
  null
  
)

export default component.exports